import { convertFromRaw } from "draft-js";

const contentStateToText = (contentState) => {
    return JSON.stringify(convertFromRaw(contentState).getPlainText().trim());
};

export default contentStateToText;

